import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

/**
 * @description Сервис для лейаутом сайта
 * @description Можно прокинуть верхний и нижний компонент, которые будут сверху и снизу layout
 */
@Injectable({
  providedIn: 'root',
})
export class GasLayoutService {
  public topComponentSubject$ = new BehaviorSubject<TemplateRef<HTMLElement>>(undefined);
  public headerBottomComponentSubject$ = new BehaviorSubject<TemplateRef<HTMLElement>>(undefined);
  public botComponentSubject$ = new BehaviorSubject<TemplateRef<HTMLElement>>(undefined);

  public topComponent$: Observable<TemplateRef<HTMLElement>> = this.topComponentSubject$.asObservable().pipe(shareReplay(1));
  public headerBottomComponent$: Observable<TemplateRef<HTMLElement>> = this.headerBottomComponentSubject$
    .asObservable().pipe(shareReplay(1));
  public botComponent$: Observable<TemplateRef<HTMLElement>> = this.botComponentSubject$.asObservable().pipe(shareReplay(1));

  public set topComponent(ref: TemplateRef<HTMLElement>) {
    this.topComponentSubject$.next(ref);
  }

  public get topComponent(): TemplateRef<HTMLElement> {
    return this.topComponentSubject$.getValue();
  }

  public set headerBottomComponent(ref: TemplateRef<HTMLElement>) {
    this.headerBottomComponentSubject$.next(ref);
  }

  public get headerBottomComponent(): TemplateRef<HTMLElement> {
    return this.headerBottomComponentSubject$.getValue();
  }

  public set botComponent(ref: TemplateRef<HTMLElement>) {
    this.botComponentSubject$.next(ref);
  }

  public get botComponent(): TemplateRef<HTMLElement> {
    return this.botComponentSubject$.getValue();
  }
}
